module.exports = __webpack_public_path__ + "img/9.4d4f0ccb.jpg";